import { render, staticRenderFns } from "./MarketerWage.vue?vue&type=template&id=ccecdefe&scoped=true"
import script from "./MarketerWage.vue?vue&type=script&lang=js"
export * from "./MarketerWage.vue?vue&type=script&lang=js"
import style0 from "./MarketerWage.vue?vue&type=style&index=0&id=ccecdefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccecdefe",
  null
  
)

export default component.exports